module.exports = __webpack_public_path__ + "static/media/codes-history.09d3d511.svg";